import React, { useState, useEffect } from "react";
import NumberFormat from "react-number-format";
import {
  Row,
  Col,
  Label,
  Form,
  FormGroup,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import t from "utils/Lang";
import ApiCaller from "../../../../api/apiCaller";

interface SiteWholeRentalCalculationModalProps {
  siteId: number;
  isView?: boolean;
  isShow?: boolean;
  onSaveCallback?: Function;
  onCancelCallback?: Function;
}

export default function SiteWholeRentalCalculationModal({
  siteId,
  isView,
  isShow,
  onSaveCallback,
  onCancelCallback,
}: SiteWholeRentalCalculationModalProps) {
  const [numberOfCalculationYears, setNumberOfCalculationYears] =
    useState<string>("0");
  const [calculationYears, setCalculationYears] = useState<Array<any>>([]);
  const [showModal, setIsShow] = useState<boolean>(isShow || false);
  const [needRecalculating, setNeedRecalculating] = useState<boolean>(false);

  const toogleModal = () => {
    setIsShow(!showModal);
  };

  const showCalculationYearUI = () => {
    const calculationYearsArray = [];
    for (let i = 0; i <= parseInt(numberOfCalculationYears, 10) - 1; i++) {
      calculationYearsArray.push({
        yearIndex: i,
      });
    }
    setCalculationYears(calculationYearsArray);
    setNeedRecalculating(true);
  };

  const getCalculationResult = async () => {
    const uri = `site_whole_rental_calculation/calculation/${siteId}`;
    const res = await ApiCaller.get(uri);
    if (res?.result) {
      // setDataManipulationMode('update');
      setCalculationYears(res?.result);
    } else {
      // setDataManipulationMode('create');
    }
  };

  const saveCalculationResult = async () => {
    const dataToSubmit = {
      calculations: calculationYears,
    };
    const uri = `site_whole_rental_calculation/calculation/${siteId}`;
    const res = await ApiCaller.post(uri, dataToSubmit);
    if (res?.status == "ok") {
      setIsShow(false);
      if (onSaveCallback) {
        onSaveCallback(res.result);
      }
    } else {
      alert(res.message);
    }
  };

  const cancelModal = () => {
    toogleModal();
    if (onCancelCallback) {
      onCancelCallback();
    }
  };

  const removeLine = (lineIndex: number) => {
    let newCalculationLines = [...calculationYears];
    newCalculationLines = newCalculationLines.filter(
      (line) => line.yearIndex !== lineIndex
    );
    newCalculationLines.forEach((line: any, index: number) => {
      line.yearIndex = index;
    });
    setCalculationYears(newCalculationLines);
    setNeedRecalculating(true);
  };

  const updateRentalAmount = (value: string, yearIndex: number) => {
    let valueData = value;
    if (value.includes(",")) {
      valueData = value.replace(/,/g, "");
    }
    const newCalculationYears = [...calculationYears];
    newCalculationYears[yearIndex] = {
      ...newCalculationYears[yearIndex],
      amount: parseFloat(valueData),
    };
    setCalculationYears(newCalculationYears);
    setNeedRecalculating(true);
  };
  const updateRentalIncreasePercentage = (value: string, yearIndex: number) => {
    const newCalculationYears = [...calculationYears];
    newCalculationYears[yearIndex] = {
      ...newCalculationYears[yearIndex],
      increase_percentage: parseFloat(value),
    };
    if (yearIndex > 0) {
      newCalculationYears.forEach((calculationYear: any, index: number) => {
        if (newCalculationYears[index - 1]) {
          calculationYear.amount =
            (1 + calculationYear.increase_percentage / 100) *
            newCalculationYears[index - 1].amount;
        }
      });
    }
    setCalculationYears(newCalculationYears);
    setNeedRecalculating(true);
  };
  const recalculateRentalData = () => {
    const newCalculationYears = [...calculationYears];
    newCalculationYears.forEach((calculationYear: any, index: number) => {
      if (calculationYear.yearIndex > 0) {
        calculationYear.amount =
          (1 + calculationYear.increase_percentage / 100) *
          newCalculationYears[index - 1].amount;
      }
    });
    setCalculationYears(newCalculationYears);
    setNeedRecalculating(false);
  };

  useEffect(() => {
    getCalculationResult();
  }, []);

  useEffect(() => {
    if (needRecalculating) recalculateRentalData();
  }, [calculationYears]);

  // Calculate pricing
  return (
    <Modal size="lg" isOpen={showModal} toggle={toogleModal}>
      <ModalHeader toggle={toogleModal}>
        {t().site_calculate_modal__title}
      </ModalHeader>
      <ModalBody>
        {!isView && (
          <Row>
            <Col xs={12}>
              <Form
                inline
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <FormGroup>
                  <Label style={styles.headerYearTitle}>
                    {t().site_calculate_modal__years}
                  </Label>
                  <Input
                    placeholder={t().site_calculate_modal__years_placeholder}
                    type="number"
                    value={numberOfCalculationYears}
                    onChange={(e) =>
                      setNumberOfCalculationYears(e.target.value)
                    }
                    style={styles.headerYearTitle}
                  />{" "}
                  <Button color="primary" onClick={showCalculationYearUI}>
                    {t().action__show}
                  </Button>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        )}
        {calculationYears && (
          <div style={styles.yearListing}>
            {calculationYears.map((calculationYear: any) => (
              <Row key={`rental-row-${calculationYear.yearIndex}`}>
                <Col xs={12} sm={2}>
                  <Label></Label>
                  <FormGroup>Năm {calculationYear.yearIndex + 1}</FormGroup>
                </Col>
                <Col xs={12} sm={4}>
                  <Label>Tỉ lệ tăng giá so với năm trước</Label>
                  <FormGroup>
                    <Input
                      type="number"
                      disabled={calculationYear.yearIndex === 0 || isView}
                      placeholder="Nhập tỉ lệ %"
                      value={calculationYear.increase_percentage}
                      onChange={(e) =>
                        updateRentalIncreasePercentage(
                          e.target.value,
                          calculationYear.yearIndex
                        )
                      }
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} sm={4}>
                  <Label>Tiền thuê VND / tháng</Label>
                  <FormGroup>
                    <NumberFormat
                      className="form-control"
                      disabled={isView}
                      thousandSeparator={true}
                      placeholder="Nhập số tiền"
                      value={calculationYear.amount}
                      onChange={(e) =>
                        updateRentalAmount(
                          e.target.value,
                          calculationYear.yearIndex
                        )
                      }
                    />
                  </FormGroup>
                </Col>
                {calculationYear.yearIndex > 0 && !isView && (
                  <Col xs={12} sm={1}>
                    <Label>Xóa</Label>
                    <FormGroup>
                      <Button
                        size="sm"
                        color="danger"
                        onClick={() => removeLine(calculationYear.yearIndex)}
                      >
                        <i className="material-icons">remove</i>
                      </Button>
                    </FormGroup>
                  </Col>
                )}
              </Row>
            ))}
          </div>
        )}
      </ModalBody>
      {!isView ? (
        <ModalFooter>
          <Button color="secondary" onClick={cancelModal}>
            {t().action__cancel}
          </Button>
          <Button color="primary" onClick={saveCalculationResult}>
            {t().action__save}
          </Button>{" "}
        </ModalFooter>
      ) : (
        <ModalFooter>
          <Button color="secondary" onClick={cancelModal}>
            {t().action__go_back}
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
}

const styles = {
  headerYearTitle: {
    marginRight: 12,
  },
  yearListing: {
    marginTop: 12,
  },
  sectionTitle: {
    marginTop: 12,
    marginLeft: 12,
    marginBottom: 12,
    paddingLeft: 12,
    paddingTop: 6,
    paddingBottom: 6,
    color: "var(--color-accent-dark)",
    borderLeft: "2px solid var(--color-accent-dark)",
    fontSize: 18,
    fontWeight: 500,
  },
  totalPriceLabel: {
    color: "var(--color-muted)",
    fontSize: 18,
    display: "flex",
    justifyContent: "flex-end",
  },
  totalPrice: {
    fontWeight: 500,
    marginLeft: 6,
  },
  summarySection: {
    marginTop: 12,
  },
  totalPriceAfterCalculationLabel: {
    fontSize: 18,
    marginTop: 12,
    display: "flex",
    justifyContent: "flex-end",
  },
  totalPriceAfterCalculation: {
    marginLeft: 6,
    fontWeight: 500,
  },
};
